import { actionTypes } from '../actions/constants';

const defaultState = {
    currency: 'USD',
    showCurrency: false,
    sessionCurrency: undefined,
    localCurrency: undefined,
};

export function currencyReducer(state = defaultState, action) {
    switch (action.type) {
        case actionTypes.POPULATE_CURRENCY:
            return {
                ...state,
                ...action.payload,
                showCurrency: true,
            };
        default:
            return state;
    }
}
